import React from 'react';
import FullPageSpinner from '../Components/Spinner/FullPageSpinner';
import CAN, {ORDERS} from "../Components/Auth/Permissions";
import { useNavigate } from 'react-router-dom';
import {ICartRef} from "../Api/Models/Cart";
import CartListTable from "../Components/Cart/OrderListTable";
import {useGetPreparedCartRefsQuery} from "../Api/PreparedCartEndpoints";
import {TableSearchFilled, HomeFilled} from "@fluentui/react-icons";
import {Button} from "@fluentui/react-components";
import { useLocalization } from '../Components/Helpers/useLocalization';

const CartDetailsPage: React.FC = () => {
    const cartList = useGetPreparedCartRefsQuery();
    const [selectedCart, setSelectedCart] = React.useState<ICartRef | undefined>(undefined);
    const nav = useNavigate()
    const navigate = useNavigate();
    const L = useLocalization();

    const canPlaceOrder = CAN(ORDERS);
    if (!canPlaceOrder) {
        navigate('/')
    }

    if (cartList.isLoading) return <FullPageSpinner />
    return (
        <React.Fragment>
        {cartList.data?.items && cartList.data.items.length > 0 ?
        <div>
            <h1>{L('localization_cart_my_carts_title')}</h1>
            <CartListTable carts={cartList.data?.items ?? []} onDetailsSelected={setSelectedCart}/>
        </div>
        : 
        <div className={'centered-content'}>
            <h1>{L('localization_cart_no_saved_carts')}</h1>
            <TableSearchFilled style={{fontSize: '24em', color: '#ddd', paddingBottom: '20px'}} />
            <Button
                icon={<HomeFilled/>}
                appearance='primary'
                style={{width: '25%', marginTop: '1em', maxWidth:'200px'}}
                onClick={() => nav('/')}
            >
                {L('localization_cart_home_button')}
            </Button>
        </div>
        }
        </React.Fragment>
    );
}

export default CartDetailsPage;